/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/5
 */
import { combineReducers } from 'redux';
import {
  RECEIVE_CATEGORY,
  RECEIVE_PRODUCT,
  RECEIVE_BRAND,
  RECEIVE_HOT,
  CHANGE_BID,
  CHANGE_CID,
  RECEIVE_PAGE_INFO
} from '../actions/home';

/**
 * init state
 */
const initState = {
  hot: [],
  pageInfo: { frontConfig: {}, problemConfigs: [] },
  brand: { current: 0, list: [] },
  category: { current: 0, list: [] },
  product: { resultList: [], pageSize: 8, totalCount: 1, totalPages: 1, current: 1 }
};

/**
 * brand about reducer
 * @param  {object} state     init state
 * @param  {object} action    brand about action object
 * @return {object}
 */
export const brand = (state = initState.brand, action) => {
  switch (action.type) {
    case RECEIVE_BRAND:
      return action.brand;
    case CHANGE_BID:
      state.current = action.bid;
      return {...state};
    default:
      return state;
  }
}

/**
 * category about reducer
 * @param  {object} state     init state
 * @param  {object} action    category about action object
 * @return {object}
 */
export const category = (state = initState.category, action) => {
  switch (action.type) {
    case RECEIVE_CATEGORY:
      return action.category;
    case CHANGE_CID:
      state.current = action.cid;
      return {...state};
    default:
      return state;
  }
};

/**
 * product about reducer
 * @param  {object} state     init state
 * @param  {object} action    product about action object
 * @return {object}
 */
export const product = (state = initState.product, action) => {
  switch (action.type) {
    case RECEIVE_PRODUCT:
      return action.product;
    default:
      return state;
  }
}

/**
 * hot product about reducer
 * 
 */
export const hot = (state = initState.hot, action) => {
  switch (action.type) {
    case RECEIVE_HOT:
      return action.hot;
    default:
      return state;
  }
}

export const pageInfo = (state = initState.pageInfo, action) => {
  switch (action.type) {
    case RECEIVE_PAGE_INFO:
      return action.pageInfo;
    default:
      return state;
  }
}

export default combineReducers({
  hot,
  brand,
  category,
  product,
  pageInfo
})



// WEBPACK FOOTER //
// ./src/reducers/home.js